import { Provider } from '@angular/core';
import { AUTHENTICATION_ENABLED, LOGIN_TIMEOUT_SCREEN_OPTIONS, NoCustomerNumberErrorDetails } from 'authentication-data';
import { LoginTimeoutScreenComponent, NoCustomerNumberErrorHandlerComponent } from 'authentication-ui';
import { provideErrorComponentHandlers } from 'error-data';
import { OrdersService } from 'lib-orders';
import { PunchoutCartComponentStore, PunchoutOrdersService } from 'punchout-data';
import { PunchoutApplicationComponentsProviderComponent } from './component-providers/punchout-application-components-provider/punchout-application-components-provider.component';
import { provideFeatureImportComponents } from 'common-util';
import { CART_CHECKOUT_HANDLER, CART_TYPE } from 'cart-data';
import { providePunchoutPromoRibbonFeature } from './punchout-promo-ribbon-feature.provider';
import { providePunchoutLeadTimeFeature } from './punchout-lead-time-feature.provider';
import { PunchoutCartCheckoutHandler } from './punchout-cart-checkout.handler';

// this feature make the site work in punchout mode, which includes:
// 1. Enable authentication for punchout users by providing AUTHENTICATION_ENABLED token with true value
// 2. Provide a custom OrdersService implementation (PunchoutOrdersService) that handles punchout specific order operations,
//    and a cart checkout handler that submits the cart to the buyer through it instead of opening the checkout form
// 3. Provide custom options for the login timeout screen to hide login and continue without login options

export function providePunchoutFeature(): Provider {
  return [
    {
      provide: AUTHENTICATION_ENABLED,
      useValue: true,
    },
    {
      provide: CART_TYPE,
      useValue: 'PUNCHOUTCART',
    },
    {
      provide: LOGIN_TIMEOUT_SCREEN_OPTIONS,
      useValue: {
        hideContinueWithoutLogin: true,
        hideLogin: true,
      },
    },
    PunchoutCartComponentStore,
    {
      provide: OrdersService,
      useClass: PunchoutOrdersService,
    },
    {
      provide: CART_CHECKOUT_HANDLER,
      useClass: PunchoutCartCheckoutHandler,
    },
    provideFeatureImportComponents(PunchoutApplicationComponentsProviderComponent),
    provideFeatureImportComponents(LoginTimeoutScreenComponent),
    provideErrorComponentHandlers({
      handles: (error) => error instanceof NoCustomerNumberErrorDetails,
      component: NoCustomerNumberErrorHandlerComponent,
    }),
    providePunchoutPromoRibbonFeature(),
    providePunchoutLeadTimeFeature(),
  ];
}

// this provides 3rd party punchout integrations
export function providePunchoutIntegrationFeature(): Provider {
  return [];
}
